import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";

import { bindActionCreators, Dispatch } from "redux";

import { ConfirmDialog } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";

import { IReleaseDetailsState } from "../ReleaseDetails.state";

import ReleaseMassagesForm from "./ReleaseMassagesForm";

interface IReleaseMessagesProps {
  state: IReleaseDetailsState;
}

const ReleaseMessages: React.FC<IReleaseMessagesProps> = ({ state }) => {
  const localizedTitles = useLocalizedValues(() => ({
    question: commonMessages.info("deleteRecordQuestion"),
    askTitle: commonMessages.title("confirmationDialog"),
    updateButtonText: commonMessages.action("update"),
    deleteButtonText: commonMessages.action("delete"),
    noButton: commonMessages.option("no"),
    yesButton: commonMessages.option("yes")
  }));

  const history = useHistory();
  const [isDialogOpened, setIsDialogOpened] = useState(false);

  useEffect(() => {
    if (state.shouldRedirect) {
      history.goBack();
    }
  }, [state.shouldRedirect, history]);

  const answers = [localizedTitles.yesButton, localizedTitles.noButton];
  const onDialogHide = useCallback(
    (answer: string) => {
      setIsDialogOpened(false);
      if (answer === localizedTitles.yesButton) {
      }
    },
    [localizedTitles]
  );

  return (
    <>
      <ReleaseMassagesForm />
      <ConfirmDialog
        show={isDialogOpened}
        onHide={onDialogHide}
        question={localizedTitles.question}
        title={localizedTitles.askTitle}
        defaultAnswer={answers[1]}
        answers={answers}
      ></ConfirmDialog>
    </>
  );
};

export default connect(
  (state: { releaseDetails: IReleaseDetailsState }) => {
    return {
      state: state.releaseDetails
    };
  },
  (dispatch: Dispatch) => bindActionCreators({}, dispatch)
)(ReleaseMessages);
